<template>
    <b-nav-item class="m-auto nav-item" :to="'/Mes-Invitations'"> 
        <i class="ti-bell ti-Icon">
            <Nb-Invitation page='header-notifications'></Nb-Invitation>
        </i> 
    </b-nav-item>
</template>

<script>


    import api from "../../config/_api";
    export default {
        name: "header-notifications",
        data (){
            return{
            }
        },
    }
</script>

<style scoped>
.ti-Icon{
    font-size: 18px;
    color: #6c757d;
    

}

.ti-Icon:hover{
    color: rgba(0, 0, 0, 0.7);
}
</style>